import {CONTEXT_MENU_TAG} from 'common/domain/constants';

export default class CalendarContextMenuRenderer {
  constructor() {
    this._shown = false;
    this._menu = document.getElementsByTagName(CONTEXT_MENU_TAG)[0];
  }

  get shown() {
    return this._shown;
  }

  show(dayClicked) {
    this._shown = true;
    this.applyPosition(this.getPosition(dayClicked));
  }

  hide() {
    this._shown = false;
    this._menu.style.display = 'none';
  }

  onresize(dayClicked, resizeCallback) {
    $(window).resize(() => {
      if (!this._shown) {
        return;
      }

      if (!this.dayIsVisible(dayClicked)) {
        return this.hide();
      }

      resizeCallback();
    });
  }

  getPosition(dayClicked) {
    let {top, left, right, bottom} = dayClicked.getBoundingClientRect();
    const dayWidth = right - left;
    const dayHeight = bottom - top;
    top = top + dayHeight + window.scrollY-3;
    left = left - dayWidth + window.scrollX+7;
    return {top, left};
  }

  applyPosition({top, left}) {
    this._menu.style.display = 'block';
    this._menu.style.top = `${top}px`;
    this._menu.style.left = `${left}px`;
  }

  hideContextMenuOnOutsideClick(hideCallback) {
    $(document).click((event) => {
      if (!$(event.target).closest(CONTEXT_MENU_TAG).length) {
        if ($(CONTEXT_MENU_TAG).is(':visible')) {
          hideCallback();
        }
      }
    });
  }

  dayIsVisible(dayClicked) {
    return $(dayClicked).is(':visible');
  }

  dayIsVacation(dayClicked) {
    return $(dayClicked).hasClass('vacation');
  }
}



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarContextMenu/calendarContextMenu.renderer.js